import { useEffect } from "react";

function upsertMeta(selector, attrs) {
  let el = document.head.querySelector(selector);
  if (!el) {
    el = document.createElement("meta");
    Object.entries(attrs).forEach(([k, v]) => {
      if (k !== "content") el.setAttribute(k, v);
    });
    document.head.appendChild(el);
  }
  Object.entries(attrs).forEach(([k, v]) => el.setAttribute(k, v));
}

export default function SEOHead({
  title,
  description,
  canonical,
  image = 'https://literent.com.ng/Logo.jpg',
  type = 'website',
  robots = 'index, follow',
  structuredData,
  keywords,
}) {
  useEffect(() => {
    const previousTitle = document.title;
    if (title) document.title = title;

    if (description) {
      upsertMeta('meta[name="description"]', { name: 'description', content: description });
      upsertMeta('meta[property="og:description"]', { property: 'og:description', content: description });
      upsertMeta('meta[name="twitter:description"]', { name: 'twitter:description', content: description });
    }
    if (keywords) {
      upsertMeta('meta[name="keywords"]', { name: 'keywords', content: keywords });
    }

    upsertMeta('meta[property="og:type"]', { property: 'og:type', content: type });
    if (title) {
      upsertMeta('meta[property="og:title"]', { property: 'og:title', content: title });
      upsertMeta('meta[name="twitter:title"]', { name: 'twitter:title', content: title });
    }
    upsertMeta('meta[property="og:image"]', { property: 'og:image', content: image });
    upsertMeta('meta[name="twitter:image"]', { name: 'twitter:image', content: image });
    upsertMeta('meta[name="twitter:card"]', { name: 'twitter:card', content: 'summary_large_image' });
    upsertMeta('meta[name="robots"]', { name: 'robots', content: robots });

    let canonicalEl = document.head.querySelector('link[rel="canonical"]');
    if (!canonicalEl) {
      canonicalEl = document.createElement('link');
      canonicalEl.setAttribute('rel', 'canonical');
      document.head.appendChild(canonicalEl);
    }
    if (canonical) {
      canonicalEl.setAttribute('href', canonical);
      upsertMeta('meta[property="og:url"]', { property: 'og:url', content: canonical });
    }

    document.head.querySelectorAll('script[data-seo-structured="true"]').forEach((node) => node.remove());
    if (structuredData) {
      const entries = Array.isArray(structuredData) ? structuredData : [structuredData];
      entries.filter(Boolean).forEach((entry) => {
        const scriptEl = document.createElement('script');
        scriptEl.type = 'application/ld+json';
        scriptEl.dataset.seoStructured = 'true';
        scriptEl.text = JSON.stringify(entry);
        document.head.appendChild(scriptEl);
      });
    }

    return () => {
      document.title = previousTitle;
      document.head.querySelectorAll('script[data-seo-structured="true"]').forEach((node) => node.remove());
    };
  }, [title, description, canonical, image, type, robots, structuredData, keywords]);

  return null;
}
